var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgZipFileIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1120_126712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1109 4.4V14.2222C15.1109 15.2044 14.3153 16 13.3331 16H2.66645C1.68423 16 0.888672 15.2044 0.888672 14.2222V1.77778C0.888672 0.795556 1.68423 0 2.66645 0H10.7109L15.1109 4.4Z",
    fill: "url(#paint0_linear_1120_126712)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7109 2.62222V0L15.1109 4.4H12.4887C11.5065 4.4 10.7109 3.60444 10.7109 2.62222Z",
    fill: "#F2AD05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.82129 1.06933H7.89062V0H6.82129V1.06933ZM7.89062 2.13867H8.95996V1.06933H7.89062V2.13867ZM6.82129 3.208H7.89062V2.13867H6.82129V3.208ZM7.89062 4.27733H8.95996V3.208H7.89062V4.27733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.82129 5.34619H7.89062V4.27686H6.82129V5.34619ZM7.89062 6.41597H8.95996V5.34663H7.89062V6.41597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.82129 7.48486H7.89062V6.41553H6.82129V7.48486ZM7.89062 8.55419H8.95996V7.48486H7.89062V8.55419ZM7.35596 11.9097H8.42529V10.8404H7.35596V11.9097ZM6.82129 9.77108V11.9097C6.82129 12.2053 7.06084 12.4444 7.35596 12.4444H8.42529C8.72084 12.4444 8.95996 12.2053 8.95996 11.9097V9.77108H6.82129Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1120_126712",
    x1: 7.99978,
    y1: 0,
    x2: 7.99978,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC63A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCA82A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1120_126712"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgZipFileIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/zip-file-icon.71c0f56156f2d402d8e57f1363d06d07.svg";